module.exports = __webpack_public_path__ + "img/s-swipe.c4527a2f.svg";